var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pf23-inFo-wrap" },
      [
        _vm.mainResponses
          ? _c(
              "div",
              { staticClass: "widM clearfix" },
              [
                _vm._l(_vm.mainResponses, function(mainAttendant, idx) {
                  return [
                    _c("SurveyParticipant", {
                      key: "mainAttendant" + idx,
                      attrs: { seq: idx, participant: mainAttendant }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      key: "mainAttendant_span" + idx,
                      staticClass: "disIb moOnly",
                      staticStyle: { padding: "2.5px" }
                    }),
                    _vm._v(" "),
                    idx < _vm.mainResponses.length - 1
                      ? _c("hr", {
                          key: "mainAttendant_hr" + idx,
                          staticClass: "moOnly",
                          staticStyle: {
                            "border-top": "1px solid #ddd",
                            background: "#f4f4f4",
                            padding: "5px 0"
                          }
                        })
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("SurveyParticipantSafe", {
          attrs: { infoAvailable: _vm.infoAvailable }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTML pf23-subTit" }, [
      _c(
        "div",
        {
          staticClass: "widM fntH4 bold padTS padBS",
          staticStyle: { color: "#fff" }
        },
        [_vm._v("참가자 정보")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM padTSM" }, [
      _c(
        "ul",
        {
          staticClass: "osResNoticeList fntE colorGray",
          staticStyle: { "padding-left": ".5em", "text-indent": "-.5em" }
        },
        [
          _c("li", [
            _vm._v("- "),
            _c("em", { staticStyle: { color: "#e11e45" } }, [_vm._v("*")]),
            _vm._v(" 표시는 필수 입력사항입니다.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "- 첨부파일은 JPG, PNG, PDF, HEIC, HEIF 형식으로 최대 10MB까지 등록하실 수 있습니다."
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-074942ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074942ee","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyParticipantInfo.vue
// module id = null
// module chunks = 